/**
 * A repository saved view's board: the board its route already fetched, paged and moved through
 * the view's own board endpoints.
 */

import type {BoardInitialPayload} from '../components/board/issues/board-payload'
import type {IssuesSavedViewBoardAdapter} from '../components/board/issues/card-actions'
import {SAVED_VIEW_ROUTE_ID} from '../routes/saved-view-route-payload'
import {createSavedViewBoardAdapter} from './create-saved-view-board-adapter'

export function createRepositoryBoardAdapter({
  board,
  owner,
  repo,
  id,
  dataUpdatedAt,
}: {
  board: BoardInitialPayload
  owner: string
  repo: string
  /** The view ID from the route, which can be a legacy global ID holding `/`, `+` or `=`. */
  id: string
  /** When the route's response last changed. Included in the key so a new response keys a new board. */
  dataUpdatedAt: number
}): IssuesSavedViewBoardAdapter {
  const viewPath = `/${owner}/${repo}/issues/views/${encodeURIComponent(id)}`
  const scope = ['repository', owner, repo, id]

  return createSavedViewBoardAdapter({
    board,
    key: [...scope, dataUpdatedAt],
    routeId: SAVED_VIEW_ROUTE_ID,
    viewPath,
    itemsPath: `${viewPath}/items`,
    deferredFieldsScope: scope,
    cardActionsScope: scope,
  })
}
